import React, { Component } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import logo from './logo.svg';
import './App.css';
const d3 = require('d3');
const moment = require('moment');
const turf = require('@turf/turf');

mapboxgl.accessToken = 'pk.eyJ1IjoiY2FzZXltbWlsbGVyIiwiYSI6ImNqOTA5MnM4ZjFmczQzMm5yeDh6dGl4bzYifQ.8UpLp0pRK-061KtJsIYViQ';

class App extends Component {

  componentDidMount() {
    const coords = [-93.266052, 44.977788];

    const conventionCenter = [-93.273765, 44.969784];
    const mspAirport = [-93.204924, 44.880662]
    const targetCenter = [-93.276179, 44.979394];
    const hennepinER = [-93.262302, 44.971848];
    const walkerArt = [-93.288781, 44.968658];
    const guthrieTheater = [-93.255924, 44.978086];
    const library = [-93.270027, 44.980265];
    const uOfM = [-93.227915, 44.973723];

    const orpheumTheater = [-93.277454, 44.976269];
    const touchdownLot = [-93.256830, 44.976441];
    const rosedaleCenter = [-93.171939, 45.012679];
    const depotSkatingRink = [-93.262401, 44.979896];

    const stPaulGov = [-93.103070, 44.955014];
    const paisleyPark = [-93.560652, 44.861696];
    const purpleRainHouse = [-93.230813, 44.940596];
    const uptownAddress = [-93.295660, 44.947097];
    const mayoChildrens = [-92.482814, 44.020813];
    const firstAvenue = [-93.276049, 44.978319];
    const mcNallySmith = [-93.097293, 44.950000];

    //these are the coordinate pairs we want to route on
    const routeArray = [
      [
        conventionCenter,
        mspAirport
      ],
      [
        targetCenter,
        hennepinER
      ],
      [
        walkerArt,
        guthrieTheater
      ],
      [
        library,
        uOfM
      ],
      [
        orpheumTheater,
        touchdownLot
      ],
      [
        rosedaleCenter,
        depotSkatingRink
      ],
      [
        mspAirport,
        conventionCenter
      ],
      [
        mayoChildrens,
        uptownAddress
      ],
      [
        uOfM,
        walkerArt
      ],
      [
        purpleRainHouse,
        paisleyPark
      ],
      [
        mcNallySmith,
        firstAvenue
      ]
    ];

    const map_00 = new mapboxgl.Map({
      container: this.mapContainer_00,
      style: 'mapbox://styles/mapbox/dark-v9',
      center: coords,
      zoom: 10,
      interactive: false
    });

    const map_01 = new mapboxgl.Map({
      container: this.mapContainer_01,
      style: 'mapbox://styles/mapbox/dark-v9',
      center: coords,
      zoom: 10,
      interactive: false
    });

    const map_20 = new mapboxgl.Map({
      container: this.mapContainer_20,
      style: 'mapbox://styles/mapbox/dark-v9',
      center: coords,
      zoom: 10,
      interactive: false
    });

    const map_21 = new mapboxgl.Map({
      container: this.mapContainer_21,
      style: 'mapbox://styles/mapbox/dark-v9',
      center: coords,
      zoom: 10,
      interactive: false
    });

    const map_30 = new mapboxgl.Map({
      container: this.mapContainer_30,
      style: 'mapbox://styles/mapbox/dark-v9',
      center: coords,
      zoom: 10,
      interactive: false
    });

    const map_31 = new mapboxgl.Map({
      container: this.mapContainer_31,
      style: 'mapbox://styles/mapbox/dark-v9',
      center: coords,
      zoom: 10,
      interactive: false
    });

    const map_40 = new mapboxgl.Map({
      container: this.mapContainer_40,
      style: 'mapbox://styles/mapbox/dark-v9',
      center: coords,
      zoom: 10,
      interactive: false
    });

    const map_41 = new mapboxgl.Map({
      container: this.mapContainer_41,
      style: 'mapbox://styles/mapbox/dark-v9',
      center: coords,
      zoom: 10,
      interactive: false
    });

    const maps = [map_00, map_01, map_20, map_21, map_30, map_31, map_40, map_41];

    const renderArray0 = (error, data_0, data_1) => {
      const data = [data_0, data_1];
      renderData(data, 0, 3);
    }

    // const renderArray1 = (error, data_0, data_1) => {
    //   const data = [data_0, data_1];
    //   renderData(data, 2, 2);
    // }

    const renderArray2 = (error, data_0, data_1) => {
      const data = [data_0, data_1];
      renderData(data, 2, 0);
    }

    const renderArray3 = (error, data_0, data_1) => {
      const data = [data_0, data_1];
      renderData(data, 4, 1);
    }

    const renderArray4 = (error, data_0, data_1) => {
      const data = [data_0, data_1];
      renderData(data, 6, 9);
    }

    const renderArray5 = (error, data_0, data_1) => {
      const data = [data_0, data_1];
      renderData(data, 8, 10);
    }

    // const formatTime = (avgTime) => {
    //   const avgMins = String(Math.floor(avgTime/60));
    //   let avgSecs = String(avgTime%60);
    //   if(avgSecs.length === 1){
    //     avgSecs = '0'+avgSecs;
    //   }
    //   console.log('average', avgMins+':'+avgSecs)
    // };

    // let statsDict = {};

    // const renderStats = (stats, num) => {
    //   console.log(num, stats);
    // };

    const renderData = (data, num, ii) => {
      // console.log(data);
      let maxTime = 0;
      let minTime = 10000;
      const startEnd = routeArray[ii];
      let dataIds = [];
      // let statArray = [];

      data.forEach((route, i) =>{
        let routeIds = [];
        // let dayMax = 0;
        // let dayMaxD;
        // let dayMin = 10000;
        // let dayMinD;
        // let allTimes = 0;
        // let tmps = {};
        route.forEach((feature) => {
          routeIds.push(feature[0]);
          feature[4] = new Date(feature[3]).toLocaleString("en-US", {timeZone: "America/Chicago"});
          feature[5] = parseInt(feature[0]);
          feature[6] = maps[num+i];
          if(feature[2] > maxTime){
            maxTime = feature[2];
          }
          if(feature[2] < minTime){
            minTime = feature[2];
          }
          // if(feature[2] > dayMax){
          //   dayMax = feature[2];
          //   dayMaxD = feature;
          // }
          // if(feature[2] < dayMin){
          //   dayMin = feature[2];
          //   dayMinD = feature;
          // }
          // allTimes += feature[2];
        });
        // tmps['dayMax'] = dayMax;
        // tmps['dayMaxD'] = dayMaxD[4];
        // tmps['dayMin'] = dayMin;
        // tmps['dayMinD'] = dayMinD[4];
        // // console.log(i, dayMax, dayMaxD[4]);
        // // console.log(i, dayMin, dayMinD[4]);
        // const avgTime = Math.round(allTimes/route.length);
        // tmps['avgTime'] = avgTime;
        // statArray.push(tmps);
        dataIds.push(routeIds);
        // statsDict[ii+'-'+i] = tmps;
      });
      // renderStats(statArray, ii);
      const half = ((maxTime - minTime)*.5)+minTime;
      const color = d3.scaleLinear()
                      .domain([minTime, half, maxTime])
                      .range(["#03ba15", "#ffd900", "#ff0000"]);

      data.forEach((route, i) => {
        let fcTmp = {
          "type": "FeatureCollection",
          "features": []
        };
        // chart
        let setNum = 350;
        if(window.innerWidth < 400){
          setNum = 320;
        }
        var margin = {top: 20, right: 5, bottom: 30, left: 35},
            width = setNum - margin.left - margin.right,
            height = 100 - margin.top - margin.bottom;

        // set the ranges
        var x = d3.scaleBand()
                  .range([0, width])
                  .padding(0.1);
        var y = d3.scaleLinear()
                  .range([height, 0]);

        // append the svg object to the body of the page
        // append a 'group' element to 'svg'
        // moves the 'group' element to the top left margin
        var svg = d3.select("#c-"+String(ii)+String(i)).append("svg")
            .attr("width", width + margin.left + margin.right)
            .attr("height", height + margin.top + margin.bottom)
          .append("g")
            .attr("transform",
                  "translate(" + margin.left + "," + margin.top + ")");

        // console.log(route);
        let newRoute = [];
        let newIds = [];
        route.sort((a, b) => a[0].localeCompare(b[0]));

        // only show bars for runs more than 10 mins apart
        let filteredRoute = [];
        route.forEach((run, i) => {
          if(i===0){
            filteredRoute.push(run);
          }
          if(i>0 && parseInt(run[0]) - parseInt(route[i-1][0]) > 600000){
            filteredRoute.push(run);
          }
        })
        // Scale the range of the data in the domains
        // x.domain(route.map(function(d) { return d[0]; }));
        x.domain(filteredRoute.map(function(d) { return d[0]; }));
        y.domain([0, maxTime]);
        // console.log(maxTime, maxTime/60);

        // append the rectangles for the bar chart
        svg.selectAll(".bar")
            .data(filteredRoute)
          .enter().append("rect")
            .attr("class", "bar")
            .attr("date-val", function(d) { return d[4]; })
            .attr("x", function(d) { return x(d[0]); })
            .attr("width", x.bandwidth())
            .attr("y", function(d) { return y(d[2]); })
            .attr("height", function(d) { return height - y(d[2]); })
            .attr("fill", function(d){ return color(d[2]); })
            .on("mouseover", function(d){
              svg.selectAll('rect').style('opacity', .2);
              d3.select(this).style('opacity', 1);
              const cMap = d[6];
              dataIds[i].forEach((id) => {
                cMap.setPaintProperty('route-'+id, 'line-opacity', 0);
              });
              cMap.setPaintProperty('route-'+d[0], 'line-opacity', 1);
              const date = moment(d[3]).format('MM/D/YYYY');
              const time = d[3].split(' ')[1].split('-')[0].split(':');
              let ending = 'AM';
              let hour = parseInt(time[0]);
              if (hour > 12){
                ending = 'PM';
                hour = hour - 12;
              }
              const mins = String(Math.round(d[2])/60).split('.')[0];
              let remainder = String(Math.round(d[2])%60);
              if(remainder.length === 1){
                remainder = '0'+remainder;
              }
              d3.select("#c-"+String(ii)+String(i)+'-time').html('<div>'+date+'</div><div>'+hour+':'+time[1]+' '+ending+'</div><div class="time-label" style="color:'+color(d[2])+';">'+mins+':'
              +remainder+'</div>');
             })
             .on("mouseout", function(d){
               const date = moment(d[3]).format('MM/D/YYYY');
               svg.selectAll('rect').style('opacity', 1);
               const cMap = d[6];
               dataIds[i].forEach((id) => {
                 cMap.setPaintProperty('route-'+id, 'line-opacity', .2);
               });
               d3.select("#c-"+String(ii)+String(i)+'-time').html(date);
             })
             .on('click', function(d){
               console.log(d);
             })

        // add the x Axis
        let cHour;
        const hourArray = ['12', '3', '6', '9'];
        svg.append("g")
            .attr("transform", "translate(0," + height + ")")
            .attr('class', 'x-axis')
            .call(d3.axisBottom(x).tickFormat(function(d, i){
              // console.log(d, new Date(parseFloat(d)).toLocaleString("en-US", {timeZone: "America/Chicago"}));
              const newDate = new Date(parseFloat(d)).toLocaleString("en-US", {timeZone: "America/Chicago"});
              const strDate = String(newDate);
              const strTime = strDate.split(', ')[1].split(':')[0];
              if(strTime === cHour){
                return;
              } else {
                cHour = strTime;
                if(hourArray.indexOf(cHour) >= 0){
                  if(cHour === '12'){
                    if(i === 0){
                      return strTime+' AM';
                    } else {
                      return strTime+' PM';
                    }
                  } else {
                    return strTime;
                  }
                }
              }
            }));

        svg.selectAll('.tick').style('opacity', function(d){
          if(d3.select(this).node().getBBox()['width'] === 0){
            return 0;
          }
        })

        // add the y Axis
        svg.append("g")
            .call(d3.axisLeft(y).ticks(3).tickFormat(function(d){
              let seconds = String(d%60);
              if(seconds.length === 1){
                seconds = '0'+seconds;
              }
              return String(d/60).split('.')[0]+':'+seconds;
            }));

        route.forEach((feature) => {
          // map section
          let rtTmp = {
                        "type": "Feature",
                        "geometry": {
                          "type": "LineString",
                          "coordinates": feature[1]
                        }
                      };
          fcTmp['features'].push(rtTmp);

          // maps[i+num].scrollZoom.disable();

          maps[i+num].addLayer({
              "id": "route-"+feature[0],
              "type": "line",
              "source": {
                  "type": "geojson",
                  "data": {
                      "type": "Feature",
                      "properties": {
                        "color": feature[2]
                      },
                      "geometry": {
                        "type": "LineString",
                        "coordinates": feature[1]
                    }
                  }
              },
              "layout": {
                  "line-join": "round",
                  "line-cap": "round"
              },
              "paint": {
                  "line-color": {
                    property: 'color',
                    stops: [
                      [minTime, "#03ba15"],
                      [half, "#ffd900"],
                      [maxTime, "#ff0000"]
                    ]
                  },
                  "line-width": 2,
                  "line-opacity": .2
              }
          });
        });

        // start and end
        maps[i+num].addSource('source-'+String(i+num), {
          type: 'geojson',
          data: {
              "type": "FeatureCollection",
              "features": [{
                  "type": "Feature",
                  "geometry": {
                      "type": "Point",
                      "coordinates": startEnd[1]
                  },
                  "properties": {
                      "color": 0
                  }
              }]
          }
        });

        maps[i+num].loadImage('images/marker_white2.png', function(error, image){
          if (error) throw error;
          maps[i+num].addImage('marker', image);
          maps[i+num].addLayer({
            "id": 'point-'+String(i+num),
            "type": "symbol",
            "source": 'source-'+String(i+num),
            "layout": {
              "icon-image": "marker",
              "icon-size": .5,
              "icon-rotation-alignment": "viewport",
              "icon-anchor": "bottom"
            }
          })
        });

        maps[i+num].addSource('source-'+String(i+num)+'-b', {
          type: 'geojson',
          data: {
              "type": "FeatureCollection",
              "features": [{
                  "type": "Feature",
                  "geometry": {
                      "type": "Point",
                      "coordinates": startEnd[0]
                  },
                  "properties": {
                      "color": 0
                  }
              }]
          }
        });

        maps[i+num].addLayer({
          "id": 'point-'+String(i+num)+'-b',
          "type": "circle",
          "source": 'source-'+String(i+num)+'-b',
          "paint": {
            'circle-radius': 5,
            "circle-color": [
                'match',
                ['number', ['get', 'color']],
                0, '#00c7ff',
                1, '#b847ff',
                '#ccc'
            ],
            "circle-stroke-color": "#fff",
            "circle-stroke-width": {
                'base': .3,
                'stops': [[2, .5], [10, 1.5]]
            }
          }
        })


        maps[i+num].on('click', function(e){
          var features = maps[i+num].queryRenderedFeatures(e.point);
          console.log(features);
        })


        const combined = turf.combine(fcTmp);
        const bbox = turf.bbox(combined);
        const bboxPoly = turf.bboxPolygon(bbox);
        const coordinates = bboxPoly['geometry']['coordinates'][0];
        const bounds = coordinates.reduce(function(bounds, coord) {
                        return bounds.extend(coord);
                    }, new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]));

        maps[i+num].fitBounds(bounds, {
            padding: 30
        });

      })
    }

    map_41.on('load', function () {
      d3.queue()
        .defer(d3.json, 'data/route-3-01-28.json')
        .defer(d3.json, 'data/route-3-02-04.json')
        .await(renderArray0);

      d3.queue()
        .defer(d3.json, 'data/route-0-01-28.json')
        .defer(d3.json, 'data/route-0-02-04.json')
        .await(renderArray2);

      d3.queue()
        .defer(d3.json, 'data/route-1-01-28.json')
        .defer(d3.json, 'data/route-1-02-04.json')
        .await(renderArray3);

      d3.queue()
        .defer(d3.json, 'data/route-9-01-28.json')
        .defer(d3.json, 'data/route-9-02-04.json')
        .await(renderArray4);

    });

  }

  render() {
    const routeText = [
      ['Convention Center', 'MSP Airport'],
      ['Target Center', 'Hennepin ER'],
      ['Walker Art Center', 'Guthrie Theater'],
      ['Library', 'University of Minnesota'],
      ['Orpheum Theater', 'Touchdown Lot'],
      ['Rosedale Center', 'Depot Skating Rink'],
      ['MSP Airport', 'Convention Center'],
      ['Mayo Children\'s', 'Uptown'],
      ['University of Minnesota', 'Walker Art Center'],
      ['Purple Rain House', 'Paisley Park'],
      ['McNally Smith College', 'First Avenue']
    ];

    const dateLabels = ['1/28/2018', '2/4/2018'];

    return (
      <div className="App">

        <div className="chunk">
          <div className="route-info">
            <div className="header-chunk">
              <h3>{routeText[3][0]}</h3>
              <h3>{routeText[3][1]}</h3>
            </div>
            <div id="r-3">
              <p>Jackie, a junior at the University of Minnesota traveled back to campus after returning a book to
                the public library downtown.</p>
              <p>Based on average travel times for both days, her trip would likely
              have taken about <b>30 seconds longer</b> this Sunday compared to if she'd returned the book a week earlier.</p>
            </div>
          </div>
          <div className="maps">
            <div className="map-container">
              <div className="container-map">
                <div className="time-display" id="c-30-time">{dateLabels[0]}</div>
                <div ref={el => this.mapContainer_00 = el} className=""></div>
              </div>
              <div className="container-chart" id="c-30"></div>
            </div>
            <div className="map-container">
              <div className="container-map">
                <div className="time-display" id="c-31-time">{dateLabels[1]}</div>
                <div ref={el => this.mapContainer_01 = el} className=""></div>
              </div>
              <div className="container-chart" id="c-31"></div>
            </div>
          </div>
        </div>

        <div className="chunk">
          <div className="route-info">
            <div className="header-chunk">
              <h3>{routeText[9][0]}</h3>
              <h3>{routeText[9][1]}</h3>
            </div>
            <div id="r-9">
              <p>Lynn, a huge Prince fan, is visiting Minneapolis for the first time and is trying to visit as many of the
                related landmarks as possible.</p>
                <p>On average, the trip between the Purple Rain House, the home of the Kid, Prince's character in Purple Rain,
                 and Paisley Park, Prince's former production complex turned museum is estimated to have taken her only <b>50 seconds longer</b> on the day
                 of the big game compared to the week before.
              </p>
            </div>
          </div>
          <div className="maps">
            <div className="map-container">
              <div className="container-map">
                <div className="time-display" id="c-90-time">{dateLabels[0]}</div>
                <div ref={el => this.mapContainer_40 = el} className=""></div>
              </div>
              <div className="container-chart" id="c-90"></div>
            </div>
            <div className="map-container">
              <div className="container-map">
                <div className="time-display" id="c-91-time">{dateLabels[1]}</div>
                <div ref={el => this.mapContainer_41 = el} className=""></div>
              </div>
              <div className="container-chart" id="c-91"></div>
            </div>
          </div>
        </div>

        <div className="chunk">
          <div className="route-info">
            <div className="header-chunk">
              <h3>{routeText[0][0]}</h3>
              <h3>{routeText[0][1]}</h3>
            </div>
            <div id="r-0">
              <p>Mike, an insurance agent who attended a conference in Minneapolis over the weekend and took a cab
                to the airport on Sunday afternoon to fly home.</p>
              <p>He expected to run into a lot of game day traffic, so he left plenty of time to spare. He was surprised;
                however, to find that the big game didn't impact his route as much as he'd expected with the trip only taking
                an average of <b>37 seconds longer</b> than the week before.</p>
            </div>
          </div>
          <div className="maps">
            <div className="map-container">
              <div className="container-map">
                <div className="time-display" id="c-00-time">{dateLabels[0]}</div>
                <div ref={el => this.mapContainer_20 = el} className=""></div>
              </div>
              <div className="container-chart" id="c-00"></div>
            </div>
            <div className="map-container">
              <div className="container-map">
                <div className="time-display" id="c-01-time">{dateLabels[1]}</div>
                <div ref={el => this.mapContainer_21 = el} className=""></div>
              </div>
              <div className="container-chart" id="c-01"></div>
            </div>
          </div>
        </div>

        <div className="chunk">
          <div className="route-info">
            <div className="header-chunk">
              <h3>{routeText[1][0]}</h3>
              <h3>{routeText[1][1]}</h3>
            </div>
            <div id="r-1">
              <p>Kevin was on his evening run, around 8:00 PM, when he slipped on some ice in front of the Target Center and broke his wrist. 
                Rather than call an ambulance, Kevin jumped in a cab and headed to the ER.</p>
                <p>Had he fallen later in the evening, his trip to the ER could have taken up to 8 minutes and 23 seconds. But given the time that
                  he fell, his trip was projected to be <b className="green">14 seconds shorter</b> than it would have been at the same time the week before.</p>
            </div>
          </div>
          <div className="maps">
            <div className="map-container">
              <div className="container-map">
                <div className="time-display" id="c-10-time">{dateLabels[0]}</div>
                <div ref={el => this.mapContainer_30 = el} className=""></div>
              </div>
              <div className="container-chart" id="c-10"></div>
            </div>
            <div className="map-container">
              <div className="container-map">
                <div className="time-display" id="c-11-time">{dateLabels[1]}</div>
                <div ref={el => this.mapContainer_31 = el} className=""></div>
              </div>
              <div className="container-chart" id="c-11"></div>
            </div>
          </div>
        </div>

      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js